<template>
  <div>
    <AppNav v-if="Object.keys(user).length"
            @menuClick="openMenu = true"
            :username="user.admin_id ? 'Admin' : user.name_f" />

    <!-- updateUser -->
    <AppSidebar v-if="Object.keys(user).length"
                @userUpdated="$emit('userUpdated')"
                :user="user"
                :open="openMenu"
                @sideBarClose="openMenu = false" />

    <div class="container">
      <section class="is-relative fill-height content-wrap">
        <router-view @userUpdated="$emit('userUpdated')"></router-view>
      </section>
    </div>
  </div>
</template>

<script>
import AppNav from '@/components/AppNav';
import AppSidebar from '@/components/AppSidebar';

export default {
  name: 'Home',
  components: {
    AppNav,
    AppSidebar,
  },
  props: {
    user: Object
  },

  data() {
    return {
      openMenu: false,
    }
  },
}
</script>

<style scoped>
.content-wrap {
  padding: 1.5rem .5rem;
}
</style>
